import React, { Component } from 'react';
import PropTypes from 'prop-types';
import POIColorPicker from '../../UserControl/IconColorPicker/POIColorPicker.';

class EditPoi extends Component {

    constructor(props) {
        super(props);

        this.state = {
            poiObj: {
                name: '',
                group: '',
                latitude: '',
                longitude: '',
                radius: '',
                email: '',
                lineToken: '',
                isEntry: false,
                isLeave: false,
                icon_color: this.props.editPoiObj.icon.color?this.props.editPoiObj.icon.color:"",
                icon_name: this.props.editPoiObj.icon.name?this.props.editPoiObj.icon.name:"",
            },
            name: ''
        };
    }

    componentWillMount(){

        const { editPoiObj } = this.props;
        
        this.setState({
            icon_color: editPoiObj.icon.color,
            icon_name: editPoiObj.icon.name,
        });
        console.log("toto componentWillMount");
    }

    onCheckIsEntry = (isEntrys) => {
        this.setState({ poiObj: { ...this.state.poiObj, isEntry: isEntrys } })
        console.log("toto onCheckIsEntry");
    }

    onCheckIsLeave = (isLeaves) => {
        this.setState({ poiObj: { ...this.state.poiObj, isLeave: isLeaves } })
        console.log("toto onCheckIsLeave");
    }

    setMarker(icon,color){
        this.setState({ poiObj: { ...this.state.poiObj, icon_name:icon, icon_color:color },icon_name:icon, icon_color:color } );
        console.log("toto setMarker",icon,color);
    }

    onClickBack = () => {
        const {onBack} = this.props;
        onBack();
    }

  render() {
      const { editPoiObj, onClickCancelEditPoi, onClickConfirmEditPoi, onClickDeletePoi } = this.props;
      const { poiObj, name,icon_name,icon_color } = this.state;
      console.log("toto tide",icon_name,icon_color)
    return (
        <div className="container-fluid">
            <div className="card">
                <div className="card-header">
                    <h5 className=""> <i class="fa fa-arrow-left" aria-hidden="true" style={{color: '#7386D5',cursor: 'pointer'}} onClick={this.onClickBack}></i> รายการ POI</h5>
                    
                </div>
                <div className="card-body">
                    {/* <h5>แก้ไขข้อมูล POI</h5> */}
                    {/* <br /> */}

                    <form>
           <div className="row">
                <div className="col-md-8">
                <div className="card">

                        <div className="card-header">
                            <strong>แก้ไขข้อมูล POI</strong>
                            {/* <button className="btn btn-danger pull-right" onClick={(e) => { e.preventDefault(); onClickDeletePoi(editPoiObj); }}  >ลบ</button> */}
                        </div>
                        <div className="card-body">
                        <div className="form-group row">
                        <label htmlFor="example-text-input" className="col-md-3 col-form-label" >ชื่อ POI</label>
                        <div className="col-md-9">
                            <input
                                className="form-control"
                                type="text"
                                id="name"
                                defaultValue={editPoiObj.name}
                                onChange={(e) => this.setState({ poiObj: { ...this.state.poiObj, name: e.target.value } })}
                                // criteriaObject: { ...criteriaObject, supplier },

                            />
                        </div>
                    </div>
                    <div className="form-group row">
                    <label htmlFor="example-text-input" className="col-md-3 col-form-label" >กลุ่ม</label>
                        <div className="col-md-9">
                            <input
                                className="form-control"
                                type="text"
                                id="group"
                                defaultValue={editPoiObj.group}
                                onChange={(e) => this.setState({ poiObj: { ...this.state.poiObj, group: e.target.value } })}
                            />
                        </div>
                    </div>
                    <div className="form-group row">
                    <label htmlFor="example-text-input" className="col-md-3 col-form-label" >Lat</label>
                        <div className="col-md-9">
                            <input
                                className="form-control"
                                type="text"
                                id="latitude"
                                defaultValue={editPoiObj.lat}
                                onChange={(e) => this.setState({ poiObj: { ...this.state.poiObj, latitude: e.target.value } })}
                            />
                        </div>
                    </div>
                    <div className="form-group row">
                    <label htmlFor="example-text-input" className="col-md-3 col-form-label" >Lng</label>
                        <div className="col-md-9">
                            <input
                                className="form-control"
                                type="text"
                                id="longitude"
                                defaultValue={editPoiObj.lng}
                                onChange={(e) => this.setState({ poiObj: { ...this.state.poiObj, longitude: e.target.value } })}
                            />
                        </div>
                    </div>
                    <div className="form-group row">
                    <label htmlFor="example-text-input" className="col-md-3 col-form-label" >รัศมี</label>
                        <div className="col-md-9">
                            <input
                                className="form-control"
                                type="text"
                                id="radius"
                                defaultValue={editPoiObj.radius}
                                onChange={(e) => this.setState({ poiObj: { ...this.state.poiObj, radius: e.target.value } })}
                            />
                        </div>
                        {/* <label>เมตร</label> */}
                    </div>
                    <hr />
                    <div className="form-group row">
                        <label htmlFor="example-text-input" className="col-md-3 col-form-label">แจ้งเตือนทางอีเมล์
                        </label>
                        <div className="col-md-9">
                            <input
                                className="form-control"
                                type="text"
                                id="email"
                                defaultValue={editPoiObj.email}
                                onChange={(e) => this.setState({ poiObj: { ...this.state.poiObj, email: e.target.value } })}
                            />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label htmlFor="example-text-input" className="col-md-3 col-form-label">Line Token
                        </label>
                        <div className="col-md-9">
                            <input
                                className="form-control"
                                type="text"
                                id="line_token"
                                defaultValue={editPoiObj.line_token}
                                onChange={(e) => this.setState({ poiObj: { ...this.state.poiObj, lineToken: e.target.value } })}
                            />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-md-3 " />
                        <label className="col-md-3">
                            <input
                                type="checkbox"
                                id="is_entry"
                                defaultChecked={editPoiObj.is_entry}
                                onChange={(e) => this.onCheckIsEntry(e.target.checked)}
                                style={{marginRight:3}}
                            />แจ้งเมื่อเข้า
                        </label>
                        <label className="col-md-6">
                            <input
                                type="checkbox"
                                id="is_leave"
                                defaultChecked={editPoiObj.is_leave}
                                onChange={(e) => this.onCheckIsLeave(e.target.checked)}
                                style={{marginRight:3}}
                            />แจ้งเมื่อออกจาก
                        </label>
                    </div>
                        </div>
                    {/* <div className="modal-bottom text-right">
                        <div className="modal-footer ">
                            <button className="btn btn-primary" onClick={(e) => { e.preventDefault(); onClickConfirmEditPoi(poiObj); }}>บันทึกข้อมูล</button>
                            <button className="btn btn-danger" onClick={() => onClickCancelEditPoi()}>ยกเลิก</button>
                        </div>
                    </div> */}
                    </div>

                </div>

                <div className="col-md-4">
                    <div className="card" style={{height:'100%'}}>
                        <div className="card-header">
                            <strong>ตั้งค่า Marker</strong>
                        </div>
                        <div className="card-body">
                        {
                            icon_name != undefined ?
                            <POIColorPicker openAlway={true} onIconColorSelected={this.setMarker.bind(this)} defaultIcon={icon_name} defaultColor={icon_color} />
                            :null
                        }
                            {/* <POIColorPicker openAlway={true} onIconColorSelected={this.setMarker.bind(this)}/> */}
                            
                        </div>
                    </div>
                </div>
            </div>
            <hr/>
                        <div className="pull-right">
                        <button className="btn btn-primary" onClick={(e) => { e.preventDefault(); onClickConfirmEditPoi(poiObj); }}>บันทึกข้อมูล</button>
                        </div>
            </form>
            
                </div>
            </div>
        
        </div>
    );
  }
}

EditPoi.propTypes = {
    editPoiObj: PropTypes.object.isRequired,
    onClickCancelEditPoi: PropTypes.func.isRequired,
    onClickConfirmEditPoi: PropTypes.func.isRequired,
    onClickDeletePoi: PropTypes.func.isRequired,
    onBack:PropTypes.func,
}

export default EditPoi;



// WEBPACK FOOTER //
// ./src/app/view/components/AdminConfig/Content/editPoi.js